// reducers.js
import {FETCH_DRAWER_MENU, FETCH_LATEST_VERSION, SET_DRAWER_MENU} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    drawerMenuData: null,
    isLoading: false,
    error: null,
};

const versionReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_DRAWER_MENU:
            return {
                ...state,
            };

        case SET_DRAWER_MENU:
            return {
                ...state,
                drawerMenuData: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default versionReducer;
